import {
  FaStar,
  FaWifi,
  FaParking,
  FaSwimmingPool,
  FaCheck,
} from "react-icons/fa";
import { Link } from "react-router-dom";

export default function HotelCardLong({ hotel }) {
  return (
    <div className="flex flex-col justify-between gap-4 rounded-xl bg-white p-4 shadow lg:flex-row">
      {/* Left: Images */}
      <div className="flex w-full flex-col md:w-1/3">
        <div className="relative">
          <img
            src={hotel.mainImage}
            alt={hotel.name}
            className="h-48 w-full rounded-lg object-cover md:h-full"
          />
          {/* Tags */}
          <div className="absolute left-2 top-2 flex gap-2">
            <span className="rounded-md bg-gray-800 px-2 py-1 text-xs text-white">
              SPONSORED
            </span>
            <span className="rounded-md bg-purple-600 px-2 py-1 text-xs text-white">
              LUXURY
            </span>
          </div>
        </div>
        <div className="mt-2 flex gap-2 overflow-x-auto overflow-y-hidden whitespace-nowrap pb-2">
          {hotel.thumbnails.map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`thumb-${index}`}
              className="h-12 w-16 flex-shrink-0 rounded-md border-2 border-blue-500 object-cover"
            />
          ))}
        </div>
      </div>

      {/* Middle: Info */}
      <div className="flex-1 px-2">
        <div className="flex items-start justify-between">
          <div>
            <h2 className="text-xl font-bold text-gray-800">{hotel.name}</h2>
            <div className="mt-1 flex items-center gap-2">
              {Array(Math.floor(hotel.rating))
                .fill(0)
                .map((_, idx) => (
                  <FaStar key={idx} className="text-yellow-400" />
                ))}
              {hotel.rating % 1 !== 0 && <FaStar className="text-yellow-200" />}
            </div>
          </div>
        </div>

        <p className="mt-1 font-medium text-blue-600">
          {hotel.location} | 13 km drive to T2 - Chhatrapati Shivaji Airport
        </p>

        <div className="mt-2">
          <span className="rounded-md border border-gray-300 px-2 py-1 text-xs text-gray-600">
            COUPLE FRIENDLY
          </span>
        </div>

        {/* Amenities */}
        <div className="mt-3 space-y-2">
          <div className="flex items-center gap-2 text-green-600">
            <FaCheck className="text-xs" />
            <span className="text-sm">
              Free Cancellation till 24 hrs before check in
            </span>
          </div>
          <div className="flex items-center gap-2 text-green-600">
            <FaCheck className="text-xs" />
            <span className="text-sm">Book with ₹0 Payment</span>
          </div>
          <div className="flex items-center gap-2 text-green-600">
            <FaCheck className="text-xs" />
            <span className="text-sm">
              Enjoy Happy Hours with 1+1 offer on Soft Beverages
            </span>
          </div>
        </div>

        {/* Special offer */}
        <div className="mt-3 flex items-center gap-2 text-red-600">
          <span className="text-yellow-500">⭐</span>
          <span className="text-sm">
            Explore Bandra's hidden gems with our complimentary electric bike
            rides
          </span>
        </div>

        {/* Pricing, rating, and booking button (moved from right side) */}
        {/* <div className="mt-2 flex w-full flex-row flex-wrap items-center justify-center gap-3 lg:justify-start">
          <span className="rounded-md bg-blue-600 px-2 py-1 text-sm font-bold text-white">
            VERY GOOD 4.5
          </span>
          <p className="m-0 text-xs text-gray-500">(8630 Ratings)</p>
          <p className="m-0 text-sm text-gray-500 line-through">
            ₹{hotel.originalPrice}
          </p>
          <p className="m-0 text-2xl font-bold text-gray-800">
            ₹{hotel.price}/Night
          </p>
          <p className="m-0 text-xs text-gray-500">+ taxes & fees</p>
        </div>
        <div className="mt-5 w-full">
          <Link
            to="/hotels/1"
            className="w-[100%] rounded-full bg-blue-600 px-6 py-3 text-center font-medium text-white transition hover:bg-blue-700"
          >
            Book now
          </Link>
        </div> */}
      </div>

      {/* Right: Pricing */}
      <div className="flex flex-col items-start justify-between text-right lg:items-end lg:border-l lg:border-gray-200 lg:pl-6">
        <div className="flex w-full flex-row items-center justify-between lg:h-full lg:flex-col lg:justify-between">
          <div className="flex items-end gap-2 lg:flex-col lg:items-end">
            <span className="rounded-md bg-blue-600 px-2 py-1 text-sm font-bold text-white">
              VERY GOOD 4.5
            </span>
            <p className="text-xs text-gray-500">(8630 Ratings)</p>
          </div>

          <div className="flex flex-row items-center gap-2 lg:mt-4 lg:flex-col lg:items-end lg:gap-0">
            <p className="text-sm text-gray-500 line-through">
              ₹{hotel.originalPrice}
            </p>
            <p className="text-2xl font-bold text-gray-800">
              ₹{hotel.price}/Night
            </p>
            <p className="text-xs text-gray-500">+ taxes & fees</p>
          </div>
        </div>

        <Link
          to="/hotels/1"
          className="mt-4 w-full rounded-full bg-blue-600 px-6 py-3 text-center font-medium text-white transition hover:bg-blue-700"
        >
          Book now
        </Link>
      </div>
    </div>
  );
}
